/* ===================================================================
   Product Page V2 — Charm Optical
   Vanilla JS, no jQuery dependency
   =================================================================== */
(function () {
  'use strict';

  /* ---------------------------------------------------------------
     1. Gallery dot indicators via IntersectionObserver
     --------------------------------------------------------------- */
  function initGallery() {
    var track = document.querySelector('.pp-gallery-track');
    var dots = document.querySelectorAll('.pp-gallery-dot');
    if (!track || dots.length === 0) return;

    // Only observe on mobile (horizontal scroll)
    if (window.innerWidth >= 768) return;

    var slides = track.querySelectorAll('.pp-gallery-slide');
    var observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          var idx = Array.prototype.indexOf.call(slides, entry.target);
          dots.forEach(function (d, i) {
            d.classList.toggle('pp-active', i === idx);
          });
        }
      });
    }, { root: track, threshold: 0.6 });

    slides.forEach(function (slide) { observer.observe(slide); });

    // Dot click scrolls to slide
    dots.forEach(function (dot, i) {
      dot.addEventListener('click', function () {
        slides[i].scrollIntoView({ behavior: 'smooth', inline: 'start', block: 'nearest' });
      });
    });
  }

  /* ---------------------------------------------------------------
     2. Variant switcher
     --------------------------------------------------------------- */
  function initVariants() {
    var swatches = document.querySelectorAll('.pp-variant-swatch');
    if (swatches.length === 0) return;

    var productSelect = document.getElementById('productSelect');
    var priceEl = document.querySelector('.pp-price');
    var variantNameEl = document.querySelector('.pp-variant-name');
    var mainImg = document.getElementById('ProductPhotoImg');
    var gallerySlides = document.querySelectorAll('.pp-gallery-slide');
    var galleryTrack = document.querySelector('.pp-gallery-track');

    swatches.forEach(function (swatch) {
      swatch.addEventListener('click', function () {
        var variantId = this.getAttribute('data-variant-id');
        var variantPrice = this.getAttribute('data-variant-price');
        var variantCompare = this.getAttribute('data-variant-compare');
        var variantSave = this.getAttribute('data-variant-save');
        var variantTitle = this.getAttribute('data-variant-title');
        var variantImg = this.getAttribute('data-variant-img');

        // Update active state
        swatches.forEach(function (s) { s.classList.remove('pp-active'); });
        this.classList.add('pp-active');

        // Update hidden select (for LensAdvizor & cart)
        if (productSelect) {
          productSelect.value = variantId;
          // Trigger change for LensAdvizor
          var evt = document.createEvent('HTMLEvents');
          evt.initEvent('change', true, false);
          productSelect.dispatchEvent(evt);
        }

        // Update price (main + sticky bar)
        if (priceEl && variantPrice) {
          priceEl.textContent = variantPrice;
        }
        var stickyPrice = document.getElementById('pp-sticky-price');
        if (stickyPrice && variantPrice) {
          stickyPrice.textContent = variantPrice;
        }

        // Update strikethrough "was" price + "You save $X" label (gated on a real compare-at)
        var compareEl = document.getElementById('pp-price-compare');
        var labelEl = document.getElementById('pp-price-label');
        var saveEl = document.getElementById('pp-price-save');
        var hasCompare = variantCompare && variantCompare.length > 0;
        if (compareEl) {
          compareEl.textContent = hasCompare ? variantCompare : '';
          compareEl.hidden = !hasCompare;
        }
        if (saveEl) {
          saveEl.textContent = hasCompare ? (variantSave || '') : '';
        }
        if (labelEl) {
          labelEl.hidden = !hasCompare;
        }
        // Wrapper holds the "online deal only" pill too — hide both when the variant isn't on sale.
        var badgesEl = document.getElementById('pp-price-badges');
        if (badgesEl) {
          badgesEl.hidden = !hasCompare;
        }

        // Update variant name display
        if (variantNameEl && variantTitle) {
          variantNameEl.textContent = variantTitle;
        }

        // Update main image (compatibility)
        if (mainImg && variantImg) {
          mainImg.src = variantImg;
        }

        // Update gallery to show only this variant's images
        updateGalleryForVariant(variantTitle);

        // Sync Charmlio so the modal shows the correct variant image + price
        if (window.CharmlioProduct) {
          window.CharmlioProduct.variantId = variantId;
          window.CharmlioProduct.formattedPrice = variantPrice;
          // Look up raw cents price from the variants array (needed for running-total math)
          var vList = window.CharmlioProduct.variants || [];
          for (var vi = 0; vi < vList.length; vi++) {
            if (String(vList[vi].id) === String(variantId)) {
              // Shopify variants[].price is already an integer in cents (e.g. 26200)
              window.CharmlioProduct.price = parseInt(vList[vi].price, 10) || 0;
              break;
            }
          }
          if (variantImg) {
            window.CharmlioProduct.image = variantImg;
            window.CharmlioProduct.imageMed = variantImg.replace(/\?/, '?width=400&');
          }
        }

        // Update URL param
        if (window.history && window.history.replaceState) {
          var url = new URL(window.location);
          url.searchParams.set('variant', variantId);
          window.history.replaceState({}, '', url.toString());
        }
      });
    });

    // Handle ?variant= on page load
    var params = new URLSearchParams(window.location.search);
    var initialVariant = params.get('variant');
    if (initialVariant) {
      var targetSwatch = document.querySelector('.pp-variant-swatch[data-variant-id="' + initialVariant + '"]');
      if (targetSwatch) {
        targetSwatch.click();
      }
    }

    // Set hero on first visible slide (initial load)
    var firstVisible = document.querySelector('.pp-gallery-slide:not(.pp-hidden)');
    if (firstVisible) firstVisible.classList.add('pp-hero');
  }

  function updateGalleryForVariant(variantTitle) {
    if (!variantTitle) return;
    var slides = document.querySelectorAll('.pp-gallery-slide');
    var firstVisible = null;

    slides.forEach(function (slide) {
      slide.classList.remove('pp-hero');
      var color = slide.getAttribute('data-variant-color');

      if (!color || color === variantTitle) {
        slide.classList.remove('pp-hidden');
        if (!firstVisible) firstVisible = slide;
      } else {
        slide.classList.add('pp-hidden');
      }
    });

    // Make the first visible slide the hero (large image)
    if (firstVisible) firstVisible.classList.add('pp-hero');

    // Update dots count
    updateDots();

    // Scroll gallery back to start
    var track = document.querySelector('.pp-gallery-track');
    if (track) track.scrollLeft = 0;
  }

  function updateDots() {
    var dotsContainer = document.querySelector('.pp-gallery-dots');
    if (!dotsContainer) return;
    var visibleSlides = document.querySelectorAll('.pp-gallery-slide:not(.pp-hidden)');
    var frag = document.createDocumentFragment();
    visibleSlides.forEach(function (_, i) {
      var dot = document.createElement('button');
      dot.className = 'pp-gallery-dot' + (i === 0 ? ' pp-active' : '');
      dot.setAttribute('aria-label', 'Go to image ' + (i + 1));
      frag.appendChild(dot);
    });
    dotsContainer.innerHTML = '';
    dotsContainer.appendChild(frag);
    // Re-init gallery observer
    initGallery();
  }

  /* ---------------------------------------------------------------
     3. Quantity counter (eye-cares)
     --------------------------------------------------------------- */
  function initQuantity() {
    var wrap = document.querySelector('.pp-quantity');
    if (!wrap) return;

    var minusBtn = wrap.querySelector('[data-pp-qty="minus"]');
    var plusBtn = wrap.querySelector('[data-pp-qty="plus"]');
    var display = wrap.querySelector('.pp-qty-value');
    var input = document.getElementById('Quantity');
    if (!minusBtn || !plusBtn || !display || !input) return;

    minusBtn.addEventListener('click', function () {
      var val = parseInt(input.value, 10) || 1;
      if (val > 1) {
        val--;
        input.value = val;
        display.textContent = val;
      }
    });

    plusBtn.addEventListener('click', function () {
      var val = parseInt(input.value, 10) || 1;
      val++;
      input.value = val;
      display.textContent = val;
    });
  }

  /* ---------------------------------------------------------------
     4. Related products AJAX loader
     --------------------------------------------------------------- */
  function initRecommendations() {
    var section = document.querySelector('.pp-recommendations');
    if (!section) return;

    var productId = section.getAttribute('data-product-id');
    var baseUrl = section.getAttribute('data-base-url');
    var limit = section.getAttribute('data-limit') || '4';

    if (!productId || !baseUrl) return;

    var requestUrl = baseUrl + '?section_id=product-recommendations-v2&product_id=' + productId + '&limit=' + limit;

    var xhr = new XMLHttpRequest();
    xhr.open('GET', requestUrl);
    xhr.onload = function () {
      if (xhr.status >= 200 && xhr.status < 300) {
        var tmp = document.createElement('div');
        tmp.innerHTML = xhr.response;
        var newContent = tmp.querySelector('.pp-recommendations');
        if (newContent) {
          section.innerHTML = newContent.innerHTML;
        }
      }
    };
    xhr.send();
  }

  /* ---------------------------------------------------------------
     5. Init all on DOM ready
     --------------------------------------------------------------- */
  /* ---------------------------------------------------------------
     5b. Sticky bar "SELECT LENSES" → triggers LensAdvizor
     --------------------------------------------------------------- */
  function initStickyLensBtn() {
    var stickyBtn = document.getElementById('pp-sticky-lenses-btn');
    if (!stickyBtn) return;

    stickyBtn.addEventListener('click', function () {
      if (window.CharmlioOpen) {
        window.CharmlioOpen();
        return;
      }
      var charmlioBtn = document.getElementById('charmlio-trigger');
      if (charmlioBtn) {
        charmlioBtn.click();
      }
    });
  }

  function initHero() {
    // Set hero on first visible slide (works for all products including single-variant)
    var firstVisible = document.querySelector('.pp-gallery-slide:not(.pp-hidden)');
    if (firstVisible) firstVisible.classList.add('pp-hero');
  }

  /* ---------------------------------------------------------------
     6. Sticky info column offset (desktop only)

     The page used to have TWO nested scroll boxes side by side — the
     gallery was height-capped with overflow-y:auto, and the info column
     had max-height + overflow-y:auto. The wheel scrolled whichever box
     the cursor sat over, so the images appeared frozen while the right
     side moved. Both inner scrollers are gone.

     Now everything scrolls with the page. When the info column is taller
     than the viewport, we push its sticky `top` negative so it scrolls up
     with the page until its bottom edge lands on screen, then pins there —
     the buy buttons stay reachable without trapping the wheel.
     --------------------------------------------------------------- */
  var PP_HEADER_OFFSET = 80;   // clears the fixed site header
  var PP_BOTTOM_GAP = 24;      // breathing room under the pinned column

  /* A column taller than the screen gets a negative sticky `top`, so it rides
     up with the page and pins only once its bottom edge is on screen. Shorter
     than the screen, it just pins under the header. */
  function stickyTopFor(height) {
    var visibleH = window.innerHeight - PP_HEADER_OFFSET - PP_BOTTOM_GAP;
    return height > visibleH
      ? window.innerHeight - height - PP_BOTTOM_GAP
      : PP_HEADER_OFFSET;
  }

  function initStickyInfo() {
    var gallery = document.querySelector('.pp-gallery');
    var info = document.querySelector('.pp-info-col');
    if (!info) return;

    // Clear any legacy inline caps that turned the gallery into a scroller
    if (gallery) {
      gallery.style.maxHeight = '';
      gallery.style.overflow = '';
      gallery.style.overflowY = '';
    }

    if (window.innerWidth < 768) {
      info.style.removeProperty('--pp-info-top');
      if (gallery) gallery.style.removeProperty('--pp-gallery-top');
      return;
    }

    info.style.setProperty('--pp-info-top', Math.round(stickyTopFor(info.offsetHeight)) + 'px');
    if (gallery) {
      gallery.style.setProperty('--pp-gallery-top', Math.round(stickyTopFor(gallery.offsetHeight)) + 'px');
    }
  }

  /* Accordions and variant switches change column heights — recompute, or the
     pin lands in the wrong place after the first open / colour change. */
  function watchInfoHeight() {
    var info = document.querySelector('.pp-info-col');
    var gallery = document.querySelector('.pp-gallery');
    if (!info) return;
    info.querySelectorAll('details').forEach(function (d) {
      d.addEventListener('toggle', initStickyInfo);
    });
    if (window.ResizeObserver) {
      var ro = new ResizeObserver(initStickyInfo);
      ro.observe(info);
      if (gallery) ro.observe(gallery);
    }
  }

  function init() {
    initGallery();
    initVariants();
    initHero();
    initQuantity();
    initRecommendations();
    initStickyLensBtn();
    initStickyInfo();
    watchInfoHeight();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  // Re-init gallery on resize (mobile <-> desktop)
  var resizeTimer;
  window.addEventListener('resize', function () {
    clearTimeout(resizeTimer);
    resizeTimer = setTimeout(function() { initGallery(); initStickyInfo(); }, 250);
  });

})();
